import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ContractorColdWorkPermitComponent } from './contractor-cold-work-permit/contractor-cold-work-permit.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmeregencyContactsComponent } from './emeregency-contacts/emeregency-contacts.component';
import { FactoryAreaComponent } from './factory-area/factory-area.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { GraphConfigurationComponent } from './graph-configuration/graph-configuration.component';
import { LessonLerntComponent } from './lesson-lernt/lesson-lernt.component';
import { LoginComponent } from './login/login.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ObservationTypeComponent } from './observation-type/observation-type.component';
import { ProactiveAssistComponent } from './proactive-assist/proactive-assist.component';
import { RiskTypesComponent } from './risk-types/risk-types.component';
import { SafetyAuditReportingComponent } from './safety-audit-reporting/safety-audit-reporting.component';
import { SafetyIndexImprovementComponent } from './safety-index-improvement/safety-index-improvement.component';
import { SafetyIndexQuestionComponent } from './safety-index-question/safety-index-question.component';
import { TeamComponent } from './team/team.component';
import { UsersComponent } from './users/users.component';
import { WorkpermitPage } from './workpermit/workpermit.page';
import { WomensSafetyDashbaordComponent } from './womens-safety-dashbaord/womens-safety-dashbaord.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'login',
    component:LoginComponent
  },
  {
    path: 'forget-password',
    component:ForgetPasswordComponent
  },
  {
    path: 'workpermit',
    component:WorkpermitPage
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('./workpermit/addsignature/addsignature.module').then( m => m.AddsignaturePageModule)
  },
  {
    path: '',
    loadChildren: () => import('./workpermit/addsignature2/addsignature2.module').then( m => m.Addsignature2PageModule)
  },
  {
    path: 'contractor-hot-work-permit',
    loadChildren: () => import('./contractor-hot-work-permit/contractor-hot-work-permit.module').then( m => m.ContractorHotWorkPermitPageModule)
  },
  {
    path: 'contractor-cold-work-permit',
    component: ContractorColdWorkPermitComponent
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
